// this file at some point will be aware of the domain is being called and will return a custom tenantId based on that
export const getTenantId = () => 'STK';
export default null;
